import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {
  Home as HomeIcon,
  Handyman as ProductsIcon,
  Info as AboutIcon,
  ContactMail as ContactIcon,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

const menuItems = [
  { text: "Products", icon: <ProductsIcon /> },
  { text: "About", icon: <AboutIcon /> },
  { text: "Contact", icon: <ContactIcon /> },
  { text: "Careers", icon: <BusinessCenterIcon /> }
];

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          background: "white",
          // borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          margin: "5px",
          top: "-5px",
          left: "-5px",
          color: "#333",
          position: "absolute",
          animation: "scrollAnimation 5s linear infinite",
        }}
      >
        <Toolbar>
          {isMobile && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isMobile ? "center" : "flex-start",
              width: "100%",
            }}
          >
            <img
              src="/CuttechSolLogo.png"
              alt="Cuttech Solutions Logo"
              style={{
                height: isMobile ? "40px" : "20px",
                marginRight: isMobile ? "0" : "10px",
                marginLeft: isMobile ? "-40px" : "0px",
              }}
            />

            {!isMobile && (
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: "bold",
                  flexGrow: 1,
                  textAlign: "left",
                  marginLeft: "10px",
                }}
              >
                CUTTECH SOLUTIONS
              </Typography>
            )}
          </Box>

          {!isMobile && (
            <Box sx={{ display: "flex", ml: "auto" }}>
              <IconButton
                color="inherit"
                component={Link}
                to="/"
                sx={{
                  "&:hover": {
                    color: "#f9d342",
                  },
                  marginRight: "30px",
                }}
              >
                <HomeIcon />
              </IconButton>
              <Button
                color="inherit"
                component={Link}
                to="/about"
                sx={{
                  "&:hover": {
                    color: "#f9d342",
                  },
                  transition: "all 0.3s ease",
                  marginRight: "30px",
                }}
              >
                About
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/products"
                sx={{
                  "&:hover": {
                    color: "#f9d342",
                  },
                  transition: "all 0.3s ease",
                  marginRight: "15px",
                }}
              >
                Products
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/contact"
                sx={{
                  "&:hover": {
                    color: "#f9d342",
                  },
                  transition: "all 0.3s ease",
                  marginRight: "30px",
                }}
              >
                Contact
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="/careers"
                sx={{
                  "&:hover": {
                    color: "#f9d342",
                  },
                  transition: "all 0.3s ease",
                  marginRight: "30px",
                }}
              >
                Careers
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            <ListItem button component={Link} to="/">
              <HomeIcon sx={{ mr: 2, color: "#f9d342" }} />
              <ListItemText
                primary="Home"
                primaryTypographyProps={{ style: { color: "#000000" } }}
              />
            </ListItem>

            {menuItems.map(({ text, icon }) => (
              <ListItem
                button
                key={text}
                component={Link}
                to={`/${text.toLowerCase()}`}
              >
                {React.cloneElement(icon, { sx: { mr: 2, color: "#f9d342" } })}
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{ style: { color: "#000000" } }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Navbar;
